import React from 'react';
import styles from './index.module.css';

export default function RedirectToHome() {
  return (
    <div data-nosnippet className={styles.copy_right_box}>
      <p className={styles.copy_right}>Copyright © 2022-2023 TinyPerfectApps. All rights reserved.</p>
    </div>
  );
}